<template>
  <div>
    <p>{{ t('computeDilutionDescription') }}</p>
    <EquationBlock :equations="equations" />
    <hr />
    <div class="row">
      <div class="col-sm">
        <FixedUnitInput
          :input-label="t('currentTDS')"
          v-model.number="currentTDS"
          :unit="t('ppmTDS')"
        />
        <GenericInput
          :input-label="t('currentVolume')"
          v-model.number="currentVol"
          :conversion-factors="ConversionFactors.volume"
        />
        <FixedUnitInput
          :input-label="t('targetTDS')"
          v-model.number="targetTDS"
          :unit="t('ppmTDS')"
        />
        <FixedUnitInput
          :input-label="t('additiveTDS')"
          v-model.number="additiveTDS"
          :unit="t('ppmTDS')"
        />
      </div>
      <div class="col-sm">
        <GenericOutput
          :output-label="t('additiveVolume')"
          :number="additiveVolume"
          :conversion-factors="ConversionFactors.volume"
          :showSplitter="false"
        />
      </div>
    </div>
  </div>
</template>

  
  <script>
  import { ref, computed, reactive } from 'vue';
  import { useI18n } from 'vue-i18n';
  import FixedUnitInput from '../inputs/FixedUnitInput.vue';
  import GenericInput from '../inputs/GenericInput.vue';
  import GenericOutput from '../inputs/GenericOutput.vue';
  import EquationBlock from '../inputs/EquationBlock.vue';
  import ConversionFactors from '../../utils/conversion_factors';
  import { defaultRound } from '../../utils/math';
  
  export default {
    components: {
      FixedUnitInput,
      GenericInput,
      GenericOutput,
      EquationBlock,
    },
    setup() {
      const currentTDS = ref(700);
      const currentVol = ref(1);
      const targetTDS = ref(100);
      const additiveTDS = ref(25);

      const { t, tm } = useI18n();

      // Create a reactive object with a function
      const translations = reactive({
        t: (key) => t(key)
      })

      const equations = computed(() => {
          return tm('tdsDilutionsEquations');
      })

    
  
      const additiveVolume = computed(() => {
        const volumeCalc =
          (targetTDS.value - currentTDS.value) *
          currentVol.value /
          (additiveTDS.value - targetTDS.value);
        return defaultRound(volumeCalc);
      });
  
      return {
        currentTDS,
        currentVol,
        targetTDS,
        additiveTDS,
        additiveVolume,
        ConversionFactors,
        equations,
        t: translations.t,
      };
    },
  };
  </script>
  